import { CloseButton } from '@chakra-ui/react';
import { FC } from 'react';

import { Alert, AlertDescription, AlertIcon } from '@bonusly/ds-alert';

import { ToastStatus } from '../types';

export interface ToastProps {
	isCloseable?: boolean;
	message: string;
	onClose?: VoidFunction;
	status?: ToastStatus;
	marginTop?: number;
}

const statusColor = (status: ToastStatus) => {
	const color = {
		info: 'blue',
		success: 'green',
		error: 'red',
	}[status];

	return (value: string | number) => `${color}.${value}`;
};

export const Toast: FC<ToastProps> = ({ isCloseable, message, onClose, status = 'info' }) => {
	const color = statusColor(status);

	return (
		<Alert alignItems="center" status={status} boxShadow="md">
			<AlertIcon color={color(500)} />
			<AlertDescription color={color(500)} flex={1} fontWeight="medium">
				{message}
			</AlertDescription>
			{isCloseable && (
				<CloseButton
					backgroundColor={color('highlight10')}
					borderRadius="full"
					color={color(800)}
					ml={2}
					onClick={onClose}
					_active={{
						backgroundColor: color('highlight20'),
					}}
					_hover={{
						backgroundColor: color('highlight20'),
					}}
				/>
			)}
		</Alert>
	);
};
